import React from 'react'
// import Medicard from "../components/Extraaddon/Medicard";
import Jobcard from '../components/Career/Jobcard';
import Techjob from '../components/Career/Techjob';

const Careerpg = () => {
  return (
    <>
    {/* <Medicard/> */}
    <Jobcard/>
    <Techjob/>
    </>
  )
}

export default Careerpg